export default __webpack_public_path__ + "static/media/head.6946ba2f.png";